import { useState, useEffect, useContext } from "react";
import CenterWrapper from "Components/CenterWrapper";
import CreateEvent from "./CreateEvent";

import EventList from "./EventList";
import { Title, EventsPaginationWrapper, Info } from "./Events.styled";
import EventsFilter from "./EventsFilter";
import Axios from "axios";
import Button from "Components/Button";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { PublicationContext } from "common/context/Publication";
import { publicationTypes } from "common/context/Publication/PublicationContext";

const Events = () => {
  const { publication } = useContext<publicationTypes>(PublicationContext);

  const [events, setEvents] = useState<any>([]);
  const [catagory, setCatagory] = useState("");
  const [LastEvaluatedKey, setLastEvaluatedKey] = useState<any>();
  const onChange = async (e: any) => {
    setCatagory(e.target.value);
    if (e.target.value === "All Events") {
      const events = await Axios.get(`/api/events?publication=${publication}`);
      setEvents(events.data.Items);
      setLastEvaluatedKey(events.data.LastEvaluatedKey);
    } else {
      const events = await Axios.put(`/api/events?publication=${publication}`, {
        category: e.target.value,
        type: "catagory",
      });
      setEvents(events.data);
      setLastEvaluatedKey(events.data.LastEvaluatedKey);
    }
  };

  const fetchEvents = async () => {
    const events = await Axios.get(`/api/events?publication=${publication}`);
    setLastEvaluatedKey(events.data.LastEvaluatedKey);
    setEvents(events.data.Items);
  };
  useEffect(() => {
    fetchEvents();
  }, []);

  const showMore = async () => {
    const data = await Axios.get(
      `/api/event_pagination?created_at=${LastEvaluatedKey.createdAt}&publication=${publication}`
    );
    setLastEvaluatedKey(data.data.LastEvaluatedKey);
    setEvents([...events, ...data.data.Items]);
  };

  return (
    <CenterWrapper>
      <Title>What's on</Title>
      <EventsFilter onChange={onChange} catagory={catagory} />
      <Info>
      Our What's On pages are designed to provide a service to local audiences.
      All submissions appear at the discretion of the site web administrator.
      </Info>
      <CreateEvent text={true} />
      <EventList eventList={events} />
      {LastEvaluatedKey && (
        <EventsPaginationWrapper>
          <Button buttonStyles="pagination" handleClick={() => showMore()}>
            show more
          </Button>
        </EventsPaginationWrapper>
      )}
    </CenterWrapper>
  );
};

export default Events;
